import { lazy, Suspense } from "react";
import { Link } from "@/lib/router-compat";
import Hero from "@/components/Hero";
import MainServiceCards from "@/components/MainServiceCards";
import Philosophy from "@/components/Philosophy";
import ClientLogos from "@/components/ClientLogos";
import ServiceAreas from "@/components/ServiceAreas";
import PortfolioSection from "@/components/PortfolioSection";
import WhatsAppCTA from "@/components/WhatsAppCTA";
import Header from "@/components/Header";
import ScrollFadeOverlay from "@/components/ScrollFadeOverlay";
import { SEOHead } from "@/components/SEOHead";
import { BreadcrumbSchema, ServiceSchema } from "@/components/StructuredData";
import GoogleRating from "@/components/GoogleRating";

// Lazy load below-the-fold components to reduce initial DOM size
const ValueProposition = lazy(() => import("@/components/ValueProposition"));
const Process = lazy(() => import("@/components/Process"));
const Differentiators = lazy(() => import("@/components/Differentiators"));
const BlogPreview = lazy(() => import("@/components/BlogPreview"));
const ServiceFAQ = lazy(() => import("@/components/ServiceFAQ"));
const FinalCTA = lazy(() => import("@/components/FinalCTA"));
const Footer = lazy(() => import("@/components/Footer"));


const Index = () => {
  return (
    <>
      
      <SEOHead
        title="Fotograf, Videoproduktion & Social Media | Clicks DMP Mannheim"
        description="Professionelle Fotografie, Videoproduktion & Social Media Content in Mannheim & Rhein-Neckar. Cinematic visuals für Hotels, Immobilien, Events & Restaurants. Deutschlandweit verfügbar. ☎ +49 176 700 27 200"
        canonical="https://clicksdmp.com"
        ogImage="https://buhajnrjzecedelnxllv.supabase.co/storage/v1/object/public/project-media/covers/1760105191013-648ywxg9str.jpg"
        schema={
          <>
            <ServiceSchema serviceType="Fotografie" name="Fotografie in Mannheim und der Rhein-Neckar-Region" path="/foto" description="Businessporträts, Produkt-, Immobilien- und Eventfotografie für Unternehmen." />
            <ServiceSchema serviceType="Videoproduktion" name="Videoproduktion in Mannheim und der Rhein-Neckar-Region" path="/film" description="Imagefilme, Recruiting-Videos, Produktvideos und Eventfilme von der Idee bis zum fertigen Schnitt." />
            <ServiceSchema serviceType="Social-Media-Content" name="Social-Media-Content aus Mannheim" path="/socialmedia" description="Reels, Stories und Fotos für Instagram, TikTok und Facebook, produziert vor Ort und fertig zum Posten." />
            <BreadcrumbSchema items={[{ name: "Startseite", url: "https://clicksdmp.com/" }]} />
          </>
        }
      />
      <div className="min-h-screen overflow-x-hidden">
        <ScrollFadeOverlay />
        <Header />
        <Hero />
        <MainServiceCards />
        
        <Philosophy />
        <ClientLogos />
        <GoogleRating />
        <Suspense fallback={<div className="min-h-screen" />}>
          <ValueProposition />
        </Suspense>
        <ServiceAreas />
        <PortfolioSection />
        <WhatsAppCTA />
        <Suspense fallback={<div className="min-h-screen" />}>
          <Process />
          <Differentiators />
          <BlogPreview />
          <ServiceFAQ />
          <FinalCTA />
          <Footer />
        </Suspense>
      </div>
    </>
  );
};

export default Index;
